module.exports = __webpack_public_path__ + "img/tstorm.53d2b843.svg";